import { render, staticRenderFns } from "./sales.vue?vue&type=template&id=2ccdcb94"
import script from "./sales.vue?vue&type=script&lang=js"
export * from "./sales.vue?vue&type=script&lang=js"
import style0 from "./sales.vue?vue&type=style&index=0&id=2ccdcb94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports